import classnames from "classnames";
import {Link} from "react-router";

import {cropWithEllipsis} from "@/lib/displayUtils";

type RUMLinkProps = {
  id: number;
  name: string;
  address: string;
  textClass?: string;
  maxLength?: number;
};

export const RUMLink = ({id, name, address, textClass, maxLength}: RUMLinkProps) => {
  const checkLink = `/rum/v2/detail/${id}`;
  return (
    <>
      <Link to={checkLink} className={classnames("d-block fw-semibold", textClass || "text-dark")}>
        {cropWithEllipsis(name, maxLength)}
      </Link>
      <Link to={checkLink} title={address}>
        <span style={{color: "rgba(30, 41, 48, 0.5)"}}>{cropWithEllipsis(address, maxLength)}</span>
      </Link>
    </>
  );
};
